
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors/annual-reports",
      function () {
        return require("private-next-pages/investors/annual-reports.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investors/annual-reports"])
      });
    }
  